import { render, staticRenderFns } from "./MediaReferenceImage.vue?vue&type=template&id=eba2e474&"
import script from "./MediaReferenceImage.vue?vue&type=script&lang=js&"
export * from "./MediaReferenceImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports